import { ConsumptionActionTypes } from './action-types';
import { UserSpace, Meter, Consumption, SortParamsArg } from 'models';

export const requestConsumptionSpaces = () =>
  ({
    type: ConsumptionActionTypes.REQUEST_CONSUMPTION_SPACES_START,
  } as const);

export const requestConsumptionSpacesSuccess = (payload: UserSpace[]) =>
  ({
    type: ConsumptionActionTypes.REQUEST_CONSUMPTION_SPACES_SUCCESS,
    payload,
  } as const);

export const requestMeters = () =>
  ({
    type: ConsumptionActionTypes.REQUEST_METERS_START,
  } as const);

export const requestMetersSuccess = (payload: Meter[]) =>
  ({
    type: ConsumptionActionTypes.REQUEST_METERS_SUCCESS,
    payload,
  } as const);

export const requestConsumptions = () =>
  ({
    type: ConsumptionActionTypes.REQUEST_CONSUMPTIONS_START,
  } as const);

export const requestConsumptionsSuccess = (payload: Consumption[]) =>
  ({
    type: ConsumptionActionTypes.REQUEST_CONSUMPTIONS_SUCCESS,
    payload,
  } as const);

export const setErrorStatus = (payload: boolean) =>
  ({
    type: ConsumptionActionTypes.SET_ERROR_STATUS,
    payload,
  } as const);

export const setStartDate = (payload: Date | null) =>
  ({
    type: ConsumptionActionTypes.SET_START_DATE,
    payload,
  } as const);

export const setEndDate = (payload: Date | null) =>
  ({
    type: ConsumptionActionTypes.SET_END_DATE,
    payload,
  } as const);

export const selectSpace = (payload: string) =>
  ({
    type: ConsumptionActionTypes.SELECT_SPACE,
    payload,
  } as const);

export const selectMeter = (payload: Meter | null) =>
  ({
    type: ConsumptionActionTypes.SELECT_METER,
    payload,
  } as const);

export const setConsumptionsSortParams = (payload: SortParamsArg) =>
  ({
    type: ConsumptionActionTypes.SET_SORT_PARAMS,
    payload,
  } as const);

export const resetState = () =>
  ({
    type: ConsumptionActionTypes.RESET_STATE,
  } as const);
